"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCountryFAQ = exports.upsertCountryFAQ = exports.deleteCountryFAQ = exports.getCountryFAQ = exports.addCountryFAQ = exports.getCountryFAQs = void 0;
const _ = require("lodash");
const getCountryFAQs = async (supabase, id) => {
    const { data, error } = await supabase
        .from("country_faq")
        .select(`*,
    modified_by_user:modified_by(id, first_name, last_name), 
    created_by_user:created_by(id, first_name, last_name)`)
        .eq("country_id", id)
        .order("order", { ascending: true });
    if (!error) {
        return data;
    }
    return [];
};
exports.getCountryFAQs = getCountryFAQs;
const addCountryFAQ = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    const faqs = await (0, exports.getCountryFAQs)(supabase, obj.country_id);
    const count = faqs.length + 1;
    if (user?.id) {
        obj.modified_by = user?.id;
        obj.created_by = user?.id;
    }
    obj.order = count;
    const { data, error } = await supabase.from("country_faq").insert([obj]);
    if (!error)
        return data;
    return error;
};
exports.addCountryFAQ = addCountryFAQ;
const getCountryFAQ = async (supabase, id) => {
    const { data, error } = await supabase
        .from("country_faq")
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getCountryFAQ = getCountryFAQ;
const deleteCountryFAQ = async (supabase, id) => {
    const { error } = await supabase.from("country_faq").delete().eq("id", id);
    return error;
};
exports.deleteCountryFAQ = deleteCountryFAQ;
const upsertCountryFAQ = async (supabase, obj) => {
    const { data, error } = await supabase
        .from("country_faq")
        .upsert(obj)
        .select();
    if (!error)
        return data;
    return error;
};
exports.upsertCountryFAQ = upsertCountryFAQ;
const updateCountryFAQ = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
    }
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("country_faq")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateCountryFAQ = updateCountryFAQ;
